function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h48v48H0z",
  opacity: 0.5
}), React.createElement("path", {
  fill: "#06C",
  fillRule: "nonzero",
  d: "M19.497 26.745c.345-.345 1.066-.184 1.61.36s.705 1.265.36 1.61l-9.882 9.883 6.208-.181c.817-.024 1.549.623 1.634 1.444.086.82-.507 1.505-1.324 1.529l-9.826.285c-.895.026-1.667-.747-1.641-1.641l.285-9.826c.024-.817.708-1.41 1.53-1.324.82.085 1.466.817 1.443 1.633l-.175 6.006zm20.622-20.15c.895-.025 1.667.747 1.641 1.642l-.285 9.825c-.023.817-.708 1.41-1.529 1.325-.82-.086-1.467-.817-1.444-1.634l.175-6.006-9.778 9.778c-.345.345-1.066.184-1.61-.36s-.705-1.265-.36-1.61l9.882-9.882-6.208.18c-.817.024-1.548-.622-1.634-1.443-.085-.821.507-1.506 1.324-1.53z"
}));

var SvgExpandIcon = function SvgExpandIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExpandIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expand-icon.753f11a5.svg";
export { ForwardRef as ReactComponent };